import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function AndroidIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M18.582 8.4a1.344 1.344 0 00-1.359-1.33 1.344 1.344 0 00-1.331 1.357l.057 5.624a1.343 1.343 0 001.359 1.329 1.343 1.343 0 001.331-1.357L18.582 8.4zM3.335 7.465l.09 8.714a1.432 1.432 0 001.45 1.419l.976-.01.031 2.976a1.345 1.345 0 002.69-.028l-.03-2.975 1.816-.018.03 2.975a1.344 1.344 0 002.69-.028l-.03-2.975.981-.01a1.435 1.435 0 001.422-1.448l-.09-8.714-12.026.122zm8.743-2.747a.507.507 0 11-.011-1.015.507.507 0 01.011 1.015zm-5.517.056a.508.508 0 11-.008-1.015.508.508 0 01.008 1.015zm5.701-2.702L13.184.35a.187.187 0 00-.076-.253.187.187 0 00-.252.077l-.931 1.739a6.466 6.466 0 00-2.642-.526 6.465 6.465 0 00-2.624.576L5.692.249A.186.186 0 005.44.177a.184.184 0 00-.072.253l.957 1.7C4.488 3.1 3.259 4.922 3.28 6.999l12.117-.122c-.02-2.077-1.283-3.87-3.136-4.804zM1.465 7.23A1.344 1.344 0 00.133 8.586l.058 5.624a1.344 1.344 0 001.359 1.33 1.342 1.342 0 001.331-1.357l-.056-5.624a1.345 1.345 0 00-1.36-1.329z" />
        </SvgIcon>
    );
}

export default AndroidIcon;
